import React, { useEffect } from 'react';
import { generatePath, useHistory, Link, useRouteMatch, Route, Switch } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Box, Breadcrumbs } from '@mui/material';
import { DirectionsCar as DirectionsCarIcon, Home as HomeIcon, ViewList as ViewListIcon } from '@mui/icons-material';
import { useIntl } from 'react-intl';
import ReceiverMobileSchedule from './Components/ReceiverMobileSchedule';
import ReceiverMobileRecentRescues from './Components/ReceiverMobileRecentRescues';
import {
  StyledRescuerBreadcrumb,
  StyledRescuerTextBreadcrumb,
} from '../../rescuerDashboard/rescuerDashboardMobile/Components/StyledRescuerBreadcrumb';
import routes from '../../../routes';
import { Roles } from '../../../models/roles';
import useActiveUser from '../../../hooks/useActiveUser';
import { getUserRolesInCurrentlySelectedSite } from '../../../services/auth';
import MobileWrapper from '../../../components/Common/MobileBottomNavWrapper';
import { fetchSiteReceiverRescuesIfNeeded } from '../../../actions/sites';
import useActiveSite from '../../../hooks/useActiveSite';

const paths = [
  generatePath(routes.mobileDashboardReceiverSchedule, { tab: 'upcoming-rescues' }),
  generatePath(routes.mobileDashboardReceiverSchedule, { tab: 'recent-rescues' }),
];

const ReceiverMobileScheduleBreadcrumb = () => {
  const { formatMessage } = useIntl();

  return (
    <Box boxShadow={0}>
      <Breadcrumbs aria-label="breadcrumb">
        <StyledRescuerBreadcrumb
          component={Link}
          to={generatePath(routes.mobileDashboard)}
          label={formatMessage({ id: 'breadcrumbs.home' })}
          icon={<HomeIcon style={{ color: '#fff' }} fontSize="small" />}
        />
        <StyledRescuerTextBreadcrumb
          component="a"
          href="#"
          label={formatMessage({ id: 'breadcrumbs.receiver-schedule' })}
        />
      </Breadcrumbs>
    </Box>
  );
};

const iconSx = {
  fontSize: '1.8rem',
};

const ReceiverMobileScheduleContainer = () => {
  const dispatch = useDispatch();
  const site = useActiveSite();
  const { url } = useRouteMatch();
  const history = useHistory();
  const activeUser = useActiveUser();
  const userRoles = getUserRolesInCurrentlySelectedSite(activeUser);
  const rolesWithAccess = userRoles.filter(
    (role) => role.role_name === Roles.ReceiverLocationAdmin || role.role_name === Roles.ReceiverLocationStaff
  );
  const { formatMessage } = useIntl();
  const receiverId = rolesWithAccess[0]?.receiver_id;

  useEffect(() => {
    if (site?.id && receiverId) {
      dispatch(fetchSiteReceiverRescuesIfNeeded(site.id, receiverId));
    }
  }, [site, receiverId]);

  const getActiveTab = () => {
    const path = paths.indexOf(url);

    return Math.max(0, path); // no negatives numbers
  };

  const bottomTabs = [
    {
      label: formatMessage({ id: 'rescuer-my-rescues-mobile.bottom-navigation.upcoming' }),
      url: paths[0],
      icon: <ViewListIcon sx={iconSx} />,
      testId: 'receiverMobileScheduleTab0',
    },
    {
      label: formatMessage({ id: 'rescuer-my-rescues-mobile.bottom-navigation.recent' }),
      url: paths[1],
      icon: <DirectionsCarIcon sx={iconSx} />,
      testId: 'receiverMobileScheduleTab1',
    },
  ];

  if (!rolesWithAccess.length) {
    return history.push(routes.index);
  }

  return (
    <MobileWrapper
      containerId="receiver-dashboard-mobile-schedule"
      breadcrumb={<ReceiverMobileScheduleBreadcrumb />}
      activeTab={getActiveTab()}
      bottomTabs={bottomTabs}
      pageContent={
        <Switch>
          <Route
            path={[generatePath(routes.mobileDashboardReceiverSchedule), paths[0]]}
            exact
            render={() => <ReceiverMobileSchedule receiverId={receiverId} />}
          />
          <Route path={paths[1]} exact render={() => <ReceiverMobileRecentRescues receiverId={receiverId} />} />
        </Switch>
      }
    />
  );
};

export default ReceiverMobileScheduleContainer;
